"use client";
import { useLocaleCtx } from "@/contexts/locale";
import countryList from "@/lib/country-list";
import * as flags from "country-flag-icons-2/react/3x2";
import { useMemo } from "react";
import PhoneInputComponent, {
  Country,
  DefaultInputComponentProps,
  Props,
} from "react-phone-number-input";
import ar from "react-phone-number-input/locale/ar";
import en from "react-phone-number-input/locale/en";
import "react-phone-number-input/style.css";

interface PhoneInputProps extends Props<DefaultInputComponentProps> {}

export function PhoneInput({ ref, ...props }: PhoneInputProps) {
  const { lang } = useLocaleCtx();

  const alphCodes = useMemo(() => {
    return countryList(lang).getAlpha2List() as unknown as Country[];
  }, []);

  return (
    <PhoneInputComponent
      {...props}
      ref={undefined}
      flags={flags}
      labels={lang === "ar" ? ar : en}
      international
      countries={alphCodes}
      defaultCountry="SA"
      numberInputProps={{
        className: "rtl:text-right ltr:pl-12",
      }}
      countrySelectProps={{
        className: "px-2 ",
      }}
      // countryCallingCodeEditable={false}
      containerComponentProps={{
        className: "relative",
      }}
    />
  );
}
